import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';

import * as rent_contracts_api from '../Api/rent_contracts_api';
import * as rent_contract_workflows_api from '../Api/rent_contract_workflows_api';

var moment = require("moment-timezone");

export interface RentContractMoniesState {
    // rent_contract_monies:any;
    contracts_list_rent_contracts_list: any;
    contracts_list_rent_contracts_list2: any;
    contracts_list_formData: any;

}
const initialState: RentContractMoniesState = {

    contracts_list_rent_contracts_list: [],
    contracts_list_rent_contracts_list2: [],
    contracts_list_formData: {
        section_id : -1,
        chinkaku_mi : true,
        chinkaku_zumi : false,
        chinkaku_zumi_henkou : true,
        application_date_start : null,
        application_date_end : null,
        contract_date_start : moment().add(-3, "month").startOf('month').format("YYYY-MM-DD"),
        contract_date_end : null,
        contractor_name1 : "",
        building_name : "",
        cloudsign_completed_at_start : null,
        cloudsign_completed_at_end : null,
        division: [1,2],
        payment_type : [],
        apply_payment_type : [],
        month_payment_type : [],
        cancel_date_start : null,
        cancel_date_end : null,
        cancel_only : false,
        cancel_not_only : false,
        type : 0,
        cloudsign_completed_at: false,
        // is_cancel : null,
    },

}



///action 
const actionCreator = actionCreatorFactory();

export const get_contracts_list_rent_contracts_list = actionCreator<any>('GET_CONTRACTS_LIST_RENT_CONTRACTS_LIST');
export const change_contracts_list_rent_contracts_list = actionCreator<any>("CHANGE_CONTRACTS_LIST_RENT_CONTRACTS_LIST");
export const change_contracts_list_rent_contracts_list2 = actionCreator<any>("CHANGE_CONTRACTS_LIST_RENT_CONTRACTS_LIST2");
export const search_contracts_list_rent_contracts_list = actionCreator<any>('SEARCH_CONTRACTS_LIST_RENT_CONTRACTS_LIST');

export const change_contracts_list_formData = actionCreator<any>('CHANGE_CONTRACTS_LIST_FORMDATA');

export const update_contracts_list_rent_contracts = actionCreator('UPDATE_CONTRACTS_LIST_RENT_CONTRACTS');



export const contractslistReducer = reducerWithInitialState(initialState)
    .case(change_contracts_list_rent_contracts_list, (state, payload) => ({ ...state, contracts_list_rent_contracts_list: payload }))
    .case(change_contracts_list_rent_contracts_list2, (state, payload) => ({ ...state, contracts_list_rent_contracts_list2: payload }))
    .case(change_contracts_list_formData, (state, payload) => ({ ...state, contracts_list_formData: payload }))



// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const ContractsListSaga = [
    takeEvery('GET_CONTRACTS_LIST_RENT_CONTRACTS_LIST', handle_get_contracts_list_rent_contracts_list),

    takeEvery('SEARCH_CONTRACTS_LIST_RENT_CONTRACTS_LIST', handle_search_contracts_list_rent_contracts_list),

    takeEvery('UPDATE_CONTRACTS_LIST_RENT_CONTRACTS', handle_update_contracts_list_rent_contracts),
];
// export default masterSaga;



function* handle_get_contracts_list_rent_contracts_list(action: any) :any {
    console.log(action.payload)
    const state = yield select();
    let contracts_list_formData = state.ContractsList.contracts_list_formData
    // let search_name = state.contractsearchReducer.search_name
    // let search_contract_date_start = state.contractsearchReducer.search_contract_date_start
    // let search_contract_date_end = state.contractsearchReducer.search_contract_date_end
    // let search_tatemono_name = state.contractsearchReducer.search_tatemono_name

    const { payload, error } = yield call(rent_contracts_api.list, contracts_list_formData);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        yield put(change_contracts_list_rent_contracts_list(payload));
        yield put(change_contracts_list_rent_contracts_list2(payload));
        yield put(search_contracts_list_rent_contracts_list(payload));
        //    yield put(get_rent_contract_monies_success(payload));

    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}

function* handle_search_contracts_list_rent_contracts_list(action: any): any {
    yield put(change_contracts_list_rent_contracts_list([]));

    const state = yield select();   // store.getState()と同じ

    let contracts_list_rent_contracts_list = state.ContractsList.contracts_list_rent_contracts_list2
    let contracts_list_formData = state.ContractsList.contracts_list_formData





    if (contracts_list_formData.contractor_name1) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => 
            (a.contractor_name1 && han2zen(kanaToHira(hankana2Zenkana(a.contractor_name1))).indexOf(han2zen(kanaToHira(hankana2Zenkana(contracts_list_formData.contractor_name1)))) !== -1) ||
          (a.contractor_kana1 && kanaToHira(hankana2Zenkana(a.contractor_kana1)).indexOf(kanaToHira(hankana2Zenkana(contracts_list_formData.contractor_name1))) !== -1)//名前　〇
        )
    }

    if (contracts_list_formData.building_name) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => 
            (a.building_name && han2zen(kanaToHira(hankana2Zenkana(a.building_name))).indexOf(han2zen(kanaToHira(hankana2Zenkana(contracts_list_formData.building_name)))) !== -1)
        )
    }

    // すべて　建物　ｐ
    if (contracts_list_formData.type > 0) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.counting == contracts_list_formData.type)
    }

    if (contracts_list_formData.section_id > 0) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.section_id == contracts_list_formData.section_id)
    }

    // // 申込日
    // if (contracts_list_formData.application_date_start) {
    //     contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.application_date && moment(a.application_date).format("YYYYMMDD") >= moment(contracts_list_formData.application_date_start).format("YYYYMMDD"))
    // }
    
    // if (contracts_list_formData.application_date_end) {
    //     contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.application_date && moment(a.application_date).format("YYYYMMDD") <= moment(contracts_list_formData.application_date_end).format("YYYYMMDD"))
    // }

    // // 契約日
    // if (contracts_list_formData.contract_date_start) {
    //     contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.contract_date && moment(a.contract_date).format("YYYYMMDD") >= moment(contracts_list_formData.contract_date_start).format("YYYYMMDD"))
    // }
    
    // if (contracts_list_formData.contract_date_end) {
    //     contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.contract_date && moment(a.contract_date).format("YYYYMMDD") <= moment(contracts_list_formData.contract_date_end).format("YYYYMMDD"))
    // }

    // 区分
    if (contracts_list_formData.division.length > 0) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => contracts_list_formData.division.includes(a.division))
    }


    // キャンセル日
    if (contracts_list_formData.cancel_date_start) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.cancel_date && moment(a.cancel_date).format("YYYYMMDD") >= moment(contracts_list_formData.cancel_date_start).format("YYYYMMDD"))
    }
    if (contracts_list_formData.cancel_date_end) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.cancel_date && moment(a.cancel_date).format("YYYYMMDD") <= moment(contracts_list_formData.cancel_date_end).format("YYYYMMDD"))
    }

    // キャンセル以外
    if (contracts_list_formData.cancel_not_only) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.cancel_date == null)
    }
    // キャンセルのみ
    if (contracts_list_formData.cancel_only) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.cancel_date)
    }

    // 電子契約
    if (contracts_list_formData.cloudsign_completed_at) {
        contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.cloudsign_completed_at)
    }


    yield put(change_contracts_list_rent_contracts_list(contracts_list_rent_contracts_list));

    function kanaToHira(str: string) {
        return String(str).replace(/[\u30a1-\u30f6]/g, function (match) {
          var chr = match.charCodeAt(0) - 0x60;
          return String.fromCharCode(chr);
        });
      }
    
    
      function han2zen(str: string) {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
      }
      function hankana2Zenkana(str: string) {
        var kanaMap: any = {
          'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
          'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
          'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
          'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
          'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
          'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
          'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
          'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
          'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
          'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
          'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
          'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
          'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
          'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
          'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
          'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
          'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
          'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
          '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
        };
    
        var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        if (str) {
          return str
            .replace(reg, function (match) {
              return kanaMap[match];
            })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
        } else {
          return str
        }
      };
}

// 基本情報更新
function* handle_update_contracts_list_rent_contracts(action: any): any {

    // alert(action.payload)

    const state = yield select();

    const { payload, error } = yield call(rent_contract_workflows_api.update, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        let contracts_list_rent_contracts_list2 = state.ContractsList.contracts_list_rent_contracts_list2

        // 一覧の情報更新
        contracts_list_rent_contracts_list2 = contracts_list_rent_contracts_list2.map(function (value: any) {
            if (value.workflow_id === action.payload) {
                // alert(payload.title)
                value.log_confirm = value.ver
            }
            return value
        })

        // 情報更新
        yield put(change_contracts_list_rent_contracts_list2(contracts_list_rent_contracts_list2));
        yield put(search_contracts_list_rent_contracts_list(contracts_list_rent_contracts_list2));



    } else {

    }
}



